import { gql } from "@apollo/react-hooks";

const buildPlayerGameStatusMutation = (playerSlot: number) => {
  // console.log("__________PLAYERE SLOT MUTATION BUILDING" + playerSlot)

  let s = queryTemplate.replace(/%SLOT%/g, playerSlot.toString());
  return gql(s);
};

const queryTemplate = `
mutation updateGame%SLOT%($id: ID! $playerId: String $score: Int $playerDisplayName: String $round: Int) {
    updateGame%SLOT% (input: {
      id : $id
  
      Player_%SLOT% : $playerId
      Player_%SLOT%_Score : $score
      Player_%SLOT%_DisplayName : $playerDisplayName
      Player_%SLOT%_Round : $round
  
    }) {
      id
      RoundTotal
      RoundCurrent
      DateStart
      QuestionSet
      Player_1
      Player_1_Score
      Player_1_DisplayName
      Player_1_Round
      Player_2
      Player_2_Score
      Player_2_DisplayName
      Player_2_Round
      Player_3
      Player_3_Score
      Player_3_DisplayName
      Player_3_Round
      Player_4
      Player_4_Score
      Player_4_DisplayName
      Player_4_Round
    }
    }
`;
export default buildPlayerGameStatusMutation;
